import {
    SearchLocation,
    SearchTransferRequest,
    TransferFlightTimeKey,
    TransferOption,
} from '@/api/Transfer/transfer.interfaces';
import { Type as IconType } from '@ui/components/Icon/Icon.interfaces';
import { Airport } from '@/api/Content/content.interfaces';
import {
    ActivityProduct,
    FerryProduct,
    FlightProduct,
    HotelProduct,
} from '@/api/Cart/cart.interfaces';

export type AnyTransferProduct =
    | FlightProduct
    | FerryProduct
    | HotelProduct
    | ActivityProduct;

export enum TransferTripStatus {
    INITIAL = 'INITIAL',
    LOADING = 'LOADING',
    LOADED = 'LOADED',
    ERROR = 'ERROR',
}

export enum TransferJourneyType {
    Unknown = 'Unknown',
    FlightHotel = 'FlightHotel',
    FlightFerry = 'FlightFerry',
    FlightFlight = 'FlightFlight',
    HotelFlight = 'HotelFlight',
    HotelFerry = 'HotelFerry',
    HotelHotel = 'HotelHotel',
    FerryFlight = 'FerryFlight',
    FerryHotel = 'FerryHotel',
    FerryFerry = 'FerryFerry',
    HotelAirport = 'HotelAirport',
    AirportHotel = 'AirportHotel',
    ActivityAirport = 'ActivityAirport',
    AirportActivity = 'AirportActivity',
}

export enum TransferProductType {
    Hotel = 'Hotel',
    Flight = 'Flight',
    Ferry = 'Ferry',
    Activity = 'Activity',
    Airport = 'Airport',
}
export interface JourneyItem {
    id: string;
    type: TransferProductType;
    productId: string;
    start: JourneyPoint;
    end: JourneyPoint;
    closestAirports?: Airport[];
}

export interface JourneyPoint {
    flightNumber?: string;
    closestAirports?: Airport[];
    date: Date;
    description: string | null;
    productType: TransferProductType;
    productId: string;
    location: SearchLocation;
}

export interface TransferConnection {
    from: JourneyPoint;
    to: JourneyPoint;
}

export interface TransferTrip {
    id: string;
    description: string;
    type: TransferJourneyType;
    status: TransferTripStatus;
    icons: IconType[];
    active: boolean;
    visible: boolean;
    request: SearchTransferRequest;
    from: JourneyPoint;
    to: JourneyPoint;
    searchFlow: TransferSearchFlow;
}

export enum TransferSearchFlow {
    Airport = 'Airport',
    Flight = 'Flight',
    Custom = 'Custom',
}

export interface TransferImportantMessage {
    title: string;
    description: string;
}

export interface TransferSearchCondition {
    validate?: (d: Date) => TransferPickupValidateResponse | undefined;
    description: TransferPickupConditionDescription;
    direction: TransferValidateDirection;
}

export interface TransferPickupConditionDescription {
    title: string;
    text?: string;
}
export interface TransferPickupValidateResponse {
    type: TransferValidateType;
    message: string;
}
export interface TransferValidateTimeParams {
    sourceDate: Date;
    targetDate: Date;
    dateComparisonType: TransferValidateDateComparison;
    minutes: {
        buffer: number;
        minimum: number;
    };
    messages?: {
        outOfRange?: string;
        minimum?: string;
        tooClose?: string;
    };
}

export interface TransferSelectionItems {
    available: TransferOption[];
    unavailable: TransferOption[];
    total: number;
}

export enum TransferValidateType {
    Warning = 'Warning',
    Invalid = 'Invalid',
}

export enum TransferValidateDateComparison {
    Before = 'Before',
    After = 'After',
}

export enum TransferValidateDirection {
    Dropoff = 'Dropoff',
    Pickup = 'Pickup',
}

export interface SetTransferTripAirportDataPayload {
    id: string;
    [key: string]: any;
    request?: Partial<Record<TransferFlightTimeKey, Date>>;
}
